import script from "./Catalogo.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalogo.vue?vue&type=script&setup=true&lang=js"

import "./Catalogo.vue?vue&type=style&index=0&id=67f0ef5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f0ef5e"]])

export default __exports__